/**
 * An in-memory cache to keep record of all widgets type on page
 */
const WidgetsCache = {
    register(id, widget) {
        // Create _cache for keeping widgets
        const registry = this._cache || (this._cache = {});
        registry[id] = widget;
    },
    destroy(id) {
        const widget = this._cache[id];
        if (widget) {
            delete this._cache[id];
        }
    },
    get(id) {
        const exists = this._cache && this._cache[id];
        if (exists) {
            return this._cache[id];
        }
        return null;
        // throw 'no widget found with the specified id:' + id;
    },
    logAll() {
        if (this._cache) {
            for (const i in this._cache) {
                console.log(this._cache[i].widgetId);
            }
        }
    },
    getAlliFrameIds() {
        const arrIFrameIds = [];
        if (this._cache) {
            for (const i in this._cache) {
                arrIFrameIds.push(this._cache[i].iframeId);
            }
        }
        return arrIFrameIds;
    }
};
export default WidgetsCache;
